// src/utils/cacheManager.js

class CacheManager {
    constructor() {
      this.CACHE_PREFIX = 'iacuzzo-app';
      this.MAX_CACHE_AGE = 24 * 60 * 60 * 1000; // 24 ore
      console.log('📦 [CACHE_MANAGER] Inizializzato');
    }
    
    // Pulisci cache scadute automaticamente
    async cleanExpiredCaches() {
      const now = Date.now();
      const lastCleanup = localStorage.getItem('last_cache_cleanup');
      
      console.log(`🧹 [CACHE_MANAGER] Controllo cache scadute: lastCleanup=${lastCleanup}, now=${now}`);
      
      if (!lastCleanup || (now - parseInt(lastCleanup)) > this.MAX_CACHE_AGE) {
        console.log('🧹 [CACHE_MANAGER] Pulizia cache scadute necessaria');
        await this.clearAllCaches();
        localStorage.setItem('last_cache_cleanup', now.toString());
      } else {
        console.log('✅ [CACHE_MANAGER] Cache non scadute');
      }
    }
    
    // Controlla integrità cache
    async validateCacheIntegrity() {
      try {
        console.log('🔍 [CACHE_MANAGER] Validazione integrità cache...');
        
        const cacheNames = await caches.keys();
        const validCaches = cacheNames.filter(name => 
          name.startsWith(this.CACHE_PREFIX)
        );
        
        console.log(`📊 [CACHE_MANAGER] Cache trovate: ${cacheNames.length}, valide: ${validCaches.length}`);
        
        if (validCaches.length === 0) {
          console.log('🔧 [CACHE_MANAGER] Cache non valide, inizializzazione...');
          await this.initializeCache();
        } else {
          console.log('✅ [CACHE_MANAGER] Cache valide');
        }
      } catch (error) {
        console.error('❌ [CACHE_MANAGER] Errore validazione cache:', error);
        await this.clearAllCaches();
      }
    }
    
    // Inizializza cache
    async initializeCache() {
      try {
        console.log('🔧 [CACHE_MANAGER] Inizializzazione cache...');
        const cache = await caches.open(`${this.CACHE_PREFIX}-${Date.now()}`);
        await cache.addAll(['/']);
        console.log('✅ [CACHE_MANAGER] Cache inizializzata');
      } catch (error) {
        console.error('❌ [CACHE_MANAGER] Errore inizializzazione cache:', error);
      }
    }
    
    // Pulisci tutte le cache
    async clearAllCaches() {
      try {
        console.log('🧹 [CACHE_MANAGER] Pulizia tutte le cache...');
        const cacheNames = await caches.keys();
        console.log(`🔍 [CACHE_MANAGER] Trovate ${cacheNames.length} cache da pulire:`, cacheNames);
        await Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
        console.log('✅ [CACHE_MANAGER] Tutte le cache sono state pulite');
      } catch (error) {
        console.error('❌ [CACHE_MANAGER] Errore pulizia cache:', error);
      }
    }
  }
  
  export const cacheManager = new CacheManager();